import { ThemeConfig, theme } from 'antd';

export type BrandTheme = 'indigo' | 'slate' | 'teal';

const brandColors: Record<BrandTheme, string> = {
  indigo: '#4F46E5', // 深邃专业
  slate: '#475569',  // 极简石板灰
  teal: '#0F766E'    // 现代科技
};

export const getThemeConfig = (mode: 'light' | 'dark', brandTheme: BrandTheme): ThemeConfig => {
  return {
    algorithm: mode === 'dark' ? theme.darkAlgorithm : theme.defaultAlgorithm,
    token: {
      colorPrimary: brandColors[brandTheme],
      borderRadiusLG: 12,
      borderRadius: 8,
      colorBgLayout: mode === 'dark' ? '#0f172a' : '#F8FAFC',
      colorBgContainer: mode === 'dark' ? '#1e293b' : '#FFFFFF',
      fontFamily: "'Inter', '-apple-system', 'Segoe UI', 'Roboto', 'PingFang SC', 'Microsoft YaHei', sans-serif",
      fontSize: 14,
      lineHeight: 1.6, // 支持英葡文下沉字母
    },
    components: {
      Layout: {
        headerBg: mode === 'dark' ? '#1e293b' : '#FFFFFF',
        siderBg: mode === 'dark' ? '#1e293b' : '#FFFFFF',
      },
      Table: {
        headerBg: mode === 'dark' ? '#334155' : '#f1f5f9',
      },
      Card: {
        borderRadiusLG: 16, // 更大的卡片圆角
        paddingLG: 24,      // 更大的卡片内边距以处理多语言
      }
    }
  };
};
